/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MediaMoveRequest } from '../../models/media-move-request';
import { MovedItem } from '../../models/moved-item';

export interface MediaControllerMoveFile$Params {
      body: MediaMoveRequest
}

export function mediaControllerMoveFile(http: HttpClient, rootUrl: string, params: MediaControllerMoveFile$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MovedItem;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerMoveFile.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MovedItem;
      }>;
    })
  );
}

mediaControllerMoveFile.PATH = '/file-manager/move';
